<template>
    <transition name="fade">
        <div class="un" v-if="type === 'live' && !mini"
            v-touch:swipe.top="() => {upNextOpen = true}"
            v-touch:swipe.bottom="() => {if($refs.upNext.scrollTop == 0) upNextOpen = false;}"
            :class="{upNextOpen}"
            :style="{'background-color': (media.color) ? media.color.replace('0.8', '0.4') : 'rgba(99, 110, 114,0.7)' }"
        >
            <Transition name="fade">
                <h3 v-if="!upNextOpen" @click="upNextOpen = true">
                    Up Next
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M22 17.5L18.5 20V15L22 17.5Z" fill="#fff" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 5L20 5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 11L20 11" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 17L14 17" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </h3>
            </Transition>

            <Transition name="fade">
                <div class="lip" v-if="upNextOpen">
                    <h3 @click="upNextOpen = false">
                        Your Queue
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M22 17.5L18.5 20V15L22 17.5Z" fill="#fff" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 5L20 5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 11L20 11" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 17L14 17" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    </h3>

                    <div class="upnext">
                        <div class="queued" ref="upNext">
                            <div class="queue" v-ripple v-for="(x,i) in upNext"
                                :key="i" @click="() => {change(i)}"
                                :style="{'background-color': x.color}"
                                :class="{tfs: media.details.country === '24/7', playing: (playerIndex === i)}">
                                <div class="logo">
                                    <img :src="x.logos[0]"/>
                                </div>
                                <span> {{ x.name }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'queue',

    props: {
        mini: Boolean,
        media: Object,
        type: String,
        change: Function,
        playerIndex: Number,
        upNext: Array,
    },

    components: { },

    data: function(){
        return {
           upNextOpen: false,
        }
    },
    computed: {
        progress(){
            return (this.currentTime / (this.media.duration || 0)) * 100
        }
    },
    methods: {
    },

    beforeUnmount: function(){ },

    mounted: function () { }

}
</script>

<style scoped lang="scss">
.un{
    width: 100vw;
    height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 1px -9px 10px 0px rgba(0, 0, 0, 0.35);
    text-transform: uppercase;
    border-radius: 15px;
    backdrop-filter: blur(20px);
    font-weight: bold;
    position: absolute;
    bottom: calc(-80vh + 80px);
    transition-duration: 0.3s;
    z-index: 99999;
    &.upNextOpen{
        bottom: 0;
        transition-duration: 0.3s;
    }
    h3{
        padding: 20px;
        display: flex;
        align-items: center;
        letter-spacing: 3px;
        justify-content: space-between;
    }

    .upnext{ }

    .queued{
        width: 100vw;
        height: calc(80vh - 100px);
        padding: 0 20px;
        box-sizing: border-box;
        overflow-y: scroll;
        text-transform: none;
        font-weight: normal;
        letter-spacing: normal;
        font-size: 11px;
        justify-content: center;
        .queue{
            display: flex;
            flex-direction: row;
            border-bottom: 1px solid white;
            padding: 10px;
            border-radius: 10px;
            opacity: 0.8;
            min-width: 100%;
            max-width: 100%;
            position: relative;
            overflow: hidden;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
            box-sizing: border-box;
            &.playing{
                border: 2px solid white;
            }
            &.tfs{
                .logo{
                    height: 75px;
                    border-radius: 9px;
                    padding: 0;
                    overflow: hidden;
                    img{
                        width: 100%;
                    }
                }
            }

            span{
                opacity: 1;
                padding-bottom: 0;
                font-weight: bold;
            }

            .logo{
                width: auto;
                height: 20px;
                padding: 0;
                margin: 0;
                img{
                    width: auto;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
}


</style>
